/** Regex to identify the presence of a time zone specifier in a date string */
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/

export default tzPattern



// WEBPACK FOOTER //
// ./node_modules/date-fns-tz/esm/_lib/tzPattern/index.js